module.exports = __webpack_public_path__ + "img/img_tab_mo.2f01f464.svg";